// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 587) return "static/chunks/587-140d33da56a00ced.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "50ac912a3b42fac3" + ".js";
};